import {Component, EventEmitter, forwardRef, Input, Optional, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator} from "@angular/forms";
import {NbinputConfig, NbFieldType, SystemAttachment} from "./nbinput.entity";
import {NbinputUploadService} from "./nbinput-upload";

@Component({
  selector: 'nbinput-image',
  template: require('./nbinput-image.component.html'),
  styles: [require('./nbinput-image.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputImageComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NbinputImageComponent),
      multi: true,
    }
  ]
})

export class NbinputImageComponent implements ControlValueAccessor, Validator {
  validate(c: AbstractControl): { [key: string]: any; } {
    this.data.forEach(e => {
      if (!e.completed || !e.success) {
        return {
          FilesOnUploading: {
            valid: false,
          },
        }
      }
    });
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {}
  writeValue(obj: SystemAttachment[]): void {
    if (obj && Array.isArray(obj)) {
      this.data = obj;
    }
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  registerOnChange(fn: any): void {
    if(fn) this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {if(fn) this.onTouchedCallback = fn;}
  onBlur() {this.onTouchedCallback();}

  @Input()
  public disabled;

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  upload;
  download;
  @Input()
  token;

  @Input()
  public readonly = false;

  @Input()
  public mime = '*';

  @Input()
  public type:NbFieldType = NbFieldType.Image;

  @Output()
  public onFileChange: EventEmitter<any> = new EventEmitter();
  submit() {
    // 只提交上传完成的文件
    const out = this.data.filter(e => e.completed && e.success);
    this.onFileChange.emit(out);
      this.onChangeCallback(out);
  }

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  @Input()
  public data: SystemAttachment[] = [];


  onChange(event) {
    for (let i = 0; i < event.target.files.length; i++){
      // event.target.data[i].callback = this.submit;
      let a = new SystemAttachment(event.target.files[i]);
      a.completed = false;
      a.url = 'default.jpg';
      this.data.push(a);
      this.uploader.upload(event.target.files[i],this.upload)
        .subscribe(e=>{
          Object.assign(a,e);
          if (e.completed) {
            this.submit();
          }
        });
    }
  }

  delImg(img) {
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i] == img) {
        this.data.splice(i,1);
        this.submit();
        break;
      }
    }
  }

  constructor(
    private uploader: NbinputUploadService,
    @Optional() private config: NbinputConfig,
  ) {
    this.upload = config.uploadAPI;
    this.download = config.downloadAPI;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-image.component.ts